<template>
  <div>
    <MainPage v-if="loaded" />
  </div>
</template>

<script>
import MainPage from "./main.page";

export default {
  name: "ChatTestPage",
  components: { MainPage },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    this.setPageContext("chat-test", () => {
      this.loaded = true;
    });
  },
  computed: {
    aspectRatio() {
      const aspectRatio = {
        sm: 2.37,
        xs: 1.59,
      };

      return aspectRatio[this.$size] || 16 / 8;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
